import React from "react";
import { Mail, Phone, MapPin, ArrowUpRight } from "lucide-react";
import { CONTACT } from "../data";
import { serif, mont, COLORS } from "./ui";

const V2Contacto = () => {
  const items = [
    { icon: Mail, label: "Email", value: CONTACT.email, href: `mailto:${CONTACT.email}`, testid: "v2-contact-email" },
    { icon: Phone, label: "Teléfono", value: CONTACT.phone, href: `tel:${CONTACT.phone.replace(/\s/g, "")}`, testid: "v2-contact-phone" },
    { icon: MapPin, label: "Dirección", value: CONTACT.address, href: null, testid: "v2-contact-address" },
  ];
  return (
    <div data-testid="v2-contacto">
      <section className="max-w-6xl mx-auto px-6 pt-10 pb-24 grid lg:grid-cols-12 gap-14">
        <div className="lg:col-span-5">
          <p className="text-xs uppercase tracking-[0.3em] mb-5" style={{ ...mont, color: COLORS.green, fontWeight: 600 }}>Contacto</p>
          <h1 className="text-5xl sm:text-6xl font-light leading-[1]" style={serif}>Hablemos de tu proyecto</h1>
          <p className="mt-7 text-lg leading-relaxed max-w-md" style={{ color: COLORS.sec }}>
            Marketing, comunicación, eventos o producción audiovisual. Escríbenos o llámanos y te atendemos directamente.
          </p>
          <a href={`mailto:${CONTACT.email}`} data-testid="v2-contact-cta" className="mt-9 inline-flex items-center gap-2 px-7 py-3.5 text-xs font-bold uppercase tracking-[0.14em]" style={{ ...mont, backgroundColor: COLORS.ink, color: "#FBF9F5" }}>
            Escríbenos un email <ArrowUpRight size={16} />
          </a>
        </div>
        <div className="lg:col-span-7">
          <div className="bg-white divide-y" style={{ border: `1px solid ${COLORS.border}`, borderColor: COLORS.border }}>
            {items.map(({ icon: Icon, label, value, href, testid }) => {
              const inner = (
                <div className="flex items-start gap-5 p-8">
                  <span className="w-12 h-12 shrink-0 rounded-full flex items-center justify-center" style={{ border: `1px solid ${COLORS.border}` }}>
                    <Icon size={20} style={{ color: COLORS.gold }} />
                  </span>
                  <div>
                    <p className="text-[11px] font-bold uppercase tracking-[0.2em]" style={{ ...mont, color: COLORS.mut }}>{label}</p>
                    <p className="mt-1.5 text-xl" style={serif}>{value}</p>
                  </div>
                </div>
              );
              return href ? <a key={testid} href={href} data-testid={testid} className="block" style={{ borderColor: COLORS.border }}>{inner}</a> : <div key={testid} data-testid={testid} style={{ borderColor: COLORS.border }}>{inner}</div>;
            })}
          </div>
        </div>
      </section>
    </div>
  );
};

export default V2Contacto;
